<template>
  <img
    :src="LoyaltyIconSvgUnl"
    alt="loyalty-bloom-tol-unlocked-small.svg"
  />
</template>

<script setup>
import LoyaltyIconSvgUnl from '@core/csg/src/assets/images/bcom/compressed/loyalty-bloom-tol-unlocked-small.svg';
</script>
